import { Link } from 'react-router-dom';

export default function GoldCoastHostLanding() {
  const spaces = [
    { icon: 'ri-home-4-line', title: 'Garage', desc: 'Lock-up or open — renters pay well for covered storage' },
    { icon: 'ri-car-line', title: 'Driveway', desc: 'Wide driveways are in huge demand on the Gold Coast' },
    { icon: 'ri-ship-line', title: 'Boat / Jet Ski Spot', desc: 'Canal-side spots earn up to $890/month' },
    { icon: 'ri-treasure-map-line', title: 'Caravan / RV Spot', desc: 'Secure outdoor storage is desperately short on the GC' },
  ];
  const trustPoints = [
    { icon: 'ri-shield-check-line', text: 'All renters ID-verified before booking' },
    { icon: 'ri-bank-card-line', text: 'Secure monthly payments direct to your bank' },
    { icon: 'ri-customer-service-line', text: 'Stashly support 7 days a week' },
    { icon: 'ri-lock-line', text: 'You approve every renter — no surprises' },
  ];

  return (
    <div className="min-h-screen bg-white font-sans">
      <div className="relative min-h-screen flex flex-col justify-center" style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Modern%20residential%20pontoon%20in%20Gold%20Coast%20canal%20estate%20with%20timber%20decking%20and%20secure%20boat%20mooring%2C%20luxury%20waterfront%20home%20with%20private%20jetty%20access%2C%20calm%20canal%20water%20reflecting%20blue%20sky&width=1920&height=1080&seq=gc-hero-001&orientation=landscape)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/80 to-blue-700/60" />
        <div className="relative max-w-3xl mx-auto px-6 py-32 text-center">
          <div className="inline-block bg-yellow-400 text-yellow-900 text-sm font-bold px-4 py-1 rounded-full mb-6 uppercase tracking-wide">NOW LAUNCHED IN GOLD COAST</div>
          <h1 className="text-5xl md:text-6xl font-extrabold text-white leading-tight mb-6">Your Gold Coast driveway, jetty or empty space could earn $500/month</h1>
          <p className="text-xl text-blue-100 mb-10 max-w-xl mx-auto">Storage costs on the Gold Coast have jumped 40% in two years. Renters are desperate for space — and your driveway, garage or caravan spot is worth real money right now.</p>
          <Link to="/signup" className="inline-block bg-yellow-400 hover:bg-yellow-300 text-yellow-900 font-bold text-xl px-10 py-5 rounded-2xl shadow-2xl transition-all">List Your Space — It's Free</Link>
          <p className="text-blue-200 text-sm mt-4">Takes 10 minutes · No lock-in · You control who books</p>
        </div>
      </div>
      <section className="bg-blue-700 py-16">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Gold Coast storage is in crisis</h2>
          <p className="text-blue-100 text-lg mb-10 max-w-2xl mx-auto">Self-storage prices have surged. Waiting lists are weeks long. Thousands of residents are searching for affordable local storage.</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[{stat:'40%',desc:'Storage price increase since 2022'},{stat:'2–4 wks',desc:'Average wait for a GC storage unit'},{stat:'3,000+',desc:'Monthly searches for GC storage'}].map((item,i)=>(
              <div key={i} className="bg-white/10 rounded-2xl p-6"><div className="text-4xl font-extrabold text-yellow-400 mb-2">{item.stat}</div><div className="text-blue-100">{item.desc}</div></div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-20 bg-gray-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12"><h2 className="text-4xl font-bold text-gray-900 mb-3">What could you earn?</h2><p className="text-gray-500 text-lg">Gold Coast average monthly earnings by space type</p></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {spaces.map((s,i)=>(
              <div key={i} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0"><i className={`${s.icon} text-blue-600 text-2xl`}></i></div>
                <div><h3 className="text-lg font-bold text-gray-900">{s.title}</h3><p className="text-gray-500 text-sm">{s.desc}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-12">List in 10 minutes</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[{n:'1',title:'Describe your space',desc:'Add photos and access details — takes about 10 minutes.'},{n:'2',title:'Set your price',desc:'You choose how much to charge. We show you what similar spaces earn nearby.'},{n:'3',title:'Get paid monthly',desc:'Renter pays Stashly, Stashly pays you — straight to your bank each month.'}].map((step,i)=>(
              <div key={i} className="flex flex-col items-center">
                <div className="w-14 h-14 bg-blue-600 text-white text-2xl font-bold rounded-full flex items-center justify-center mb-4">{step.n}</div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-500 text-sm">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-10">You're protected</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {trustPoints.map((t,i)=>(
              <div key={i} className="flex items-center gap-4 bg-white rounded-xl p-5 shadow-sm border border-gray-100">
                <i className={`${t.icon} text-blue-600 text-2xl flex-shrink-0`}></i>
                <span className="text-gray-700 font-medium">{t.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-24 bg-blue-700">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-extrabold text-white mb-4">Ready to start earning?</h2>
          <p className="text-blue-100 text-lg mb-10">Join Gold Coast hosts already earning monthly income from their spare space. Free to list, takes 10 minutes.</p>
          <Link to="/signup" className="inline-block bg-yellow-400 hover:bg-yellow-300 text-yellow-900 font-bold text-xl px-10 py-5 rounded-2xl shadow-2xl transition-all">List Your Space — It's Free</Link>
          <p className="text-blue-200 text-sm mt-4">No lock-in · You approve every booking · Cancel anytime</p>
        </div>
      </section>
      <footer className="bg-gray-900 py-6 text-center text-gray-500 text-sm">
        © 2026 Stashly Technologies Pty Ltd · <a href="/terms" className="hover:text-white transition-colors">Terms</a> · <a href="/privacy" className="hover:text-white transition-colors">Privacy</a>
      </footer>
    </div>
  );
}
